/*!
 * BKS Global Animations v1.1 — Kubrick register
 * GSAP 3 + ScrollTrigger — slow, deliberate reveals
 * Timing: Barry Lyndon dissolves, not commercial snap
 */
(function () {
  'use strict';

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  // reduced-motion: no motion, contenuto istantaneo (non nasconde nulla)
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    gsap.defaults({ duration: 0 });
  }

  // ── Utility: scroll-triggered fade+rise ─────────────────────────────────────
  function fadeUp(selector, extra) {
    gsap.utils.toArray(selector).forEach(function (el) {
      gsap.from(el, Object.assign({
        opacity: 0, y: 20, duration: 1.0, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 92%', once: true }
      }, extra || {}));
    });
  }

  // ── Kickers / eyebrows — short rise, longer duration ────────────────────────
  fadeUp('[class*="__kicker"]:not([class*="bks-vo"]), [class*="__eyebrow"]', { y: 8, duration: 0.80 });

  // ── Main headings — full Kubrick hold (1.2s) ──────────────────────────────────
  fadeUp('[class*="bks"]:not(.bks-vo):not([class*="bks-vo"]) h1, [class*="bks"]:not(.bks-vo):not([class*="bks-vo"]) h2', { y: 24, duration: 1.20 });

  // ── Subtitles ────────────────────────────────────────────────────────────────
  fadeUp('[class*="__subtitle"]', { y: 14, duration: 0.90, delay: 0.14 });

  // ── BKS Weekly Editorial — masthead slow fade ────────────────────────────────
  gsap.utils.toArray('.bks-ed__masthead').forEach(function (el) {
    gsap.from(el, {
      opacity: 0, duration: 1.0, ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 88%', once: true }
    });
  });

  // ── BKS Verse process steps — stagger with longer delay ──────────────────────
  gsap.utils.toArray('[class*="vproc__step"], [class*="__process-step"]').forEach(function (el, i) {
    gsap.from(el, {
      opacity: 0, y: 20, duration: 0.85, ease: 'power2.out', delay: i * 0.12,
      scrollTrigger: { trigger: el, start: 'top 90%', once: true }
    });
  });

  // ── Orbit — animated combo counter ───────────────────────────────────────────
  document.querySelectorAll('[id^="bks-vo-total-"]').forEach(function (el) {
    var target = parseInt(el.textContent.replace(/[^0-9]/g, ''), 10);
    if (!target) return;
    var obj = { val: 0 };
    el.textContent = '0';
    gsap.to(obj, {
      val: target, duration: 2.8, ease: 'power2.out',
      onUpdate: function () { el.textContent = Math.round(obj.val); },
      scrollTrigger: { trigger: el, start: 'top 82%', once: true }
    });
  });

  // ── Orbit — leaderboard rows stagger ─────────────────────────────────────────
  document.querySelectorAll('[id^="bks-vo-lb-"]').forEach(function (lb) {
    var rows = lb.querySelectorAll('[id^="bks-vo-row-"]');
    if (!rows.length) return;
    gsap.from(Array.from(rows), {
      opacity: 0, x: -16, duration: 0.55,
      stagger: 0.065, ease: 'power2.out',
      scrollTrigger: { trigger: lb, start: 'top 84%', once: true }
    });
  });

  // ── Generic BKS media / image blocks — slow scale (Barry Lyndon) ─────────────
  gsap.utils.toArray(
    '[class*="bks"][class*="__media"], [class*="bks"][class*="__image-wrap"]'
  ).forEach(function (el) {
    gsap.from(el, {
      opacity: 0, scale: 0.98, duration: 1.15, ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 88%', once: true }
    });
  });

  // ── Signal: orbit section and any section waiting for GSAP ───────────────────
  window.dispatchEvent(new CustomEvent('bks:gsap-ready'));
})();
